import { render, staticRenderFns } from "./user_info.vue?vue&type=template&id=74c14ce2&scoped=true"
import script from "./user_info.vue?vue&type=script&lang=js"
export * from "./user_info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c14ce2",
  null
  
)

export default component.exports